import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

function CurrentTournament() {
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    const fetchActiveTournaments = async () => {
      try {
        // Verwende öffentlichen Endpunkt für alle aktiven Turniere
        const response = await axios.get('/api/tournaments/active/all');
        setTournaments(response.data);
      } catch (err) {
        console.error('Fehler beim Laden der aktiven Turniere:', err);
        setError('Fehler beim Laden der Turniere.');
      } finally {
        setLoading(false);
      }
    };

    fetchActiveTournaments();
  }, []);

  const handleTournamentClick = (tournamentId) => {
    navigate(`/tournament/${tournamentId}`);
  };

  if (loading) {
    return (
      <div className="card">
        <h2>{t('currentTournament.title')}</h2>
        <p>{t('currentTournament.loading')}</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card">
        <h2>{t('currentTournament.title')}</h2>
        <div className="card" style={{
          padding: '20px',
          backgroundColor: 'rgba(239, 68, 68, 0.1)',
          border: '1px solid rgba(239, 68, 68, 0.3)',
          marginTop: '20px'
        }}>
          <p style={{ margin: 0, color: '#fca5a5' }}>{error}</p>
        </div>
      </div>
    );
  }

  if (tournaments.length === 0) {
    return (
      <div className="card">
        <h2>{t('currentTournament.title')}</h2>
        <div className="card" style={{
          padding: '20px',
          backgroundColor: 'rgba(250, 204, 21, 0.1)',
          border: '1px solid rgba(250, 204, 21, 0.3)',
          marginTop: '20px'
        }}>
          <p style={{ margin: 0, color: '#fbbf24' }}>
            {t('currentTournament.noTournaments')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <h2 style={{ marginBottom: '24px' }}>{t('currentTournament.title')}</h2>

      <div className="tournament-list">
        {tournaments.map((tournament) => (
          <div
            key={tournament.id}
            className="tournament-card"
            onClick={() => handleTournamentClick(tournament.id)}
          >
            <div className="tournament-header">
              <h3 className="tournament-name">{tournament.name}</h3>
              <span className="tournament-type-badge">
                {tournament.tournament_type === 'ko' ? '🏆 KO' :
                 tournament.tournament_type === 'groups' ? '🔄 Round Robin' :
                 tournament.tournament_type === 'americano' ? '🇺🇸 Americano' :
                 tournament.tournament_type === 'ko_placement' ? '🥇 KO+Monrad' :
                 tournament.tournament_type === 'landesliga' ? '🏓 Landesliga' :
                 '🇲🇽 Mexicano'}
              </span>
            </div>

            <div className="tournament-info">
              <div className="tournament-info-item">
                <span className="info-icon">📅</span>
                <span className="info-text">{tournament.date || '-'}</span>
              </div>
              <div className="tournament-info-item">
                <span className="info-icon">👥</span>
                <span className="info-text">{tournament.num_teams} Teams</span>
              </div>
              <div className="tournament-info-item">
                <span className="info-icon">🏟️</span>
                <span className="info-text">{tournament.num_courts} Courts</span>
              </div>
              {(tournament.created_by_first_name || tournament.created_by_last_name) && (
                <div className="tournament-info-item">
                  <span className="info-icon">👤</span>
                  <span className="info-text">{[tournament.created_by_first_name, tournament.created_by_last_name].filter(Boolean).join(' ')}</span>
                </div>
              )}
            </div>

            {tournament.description && (
              <p className="tournament-description">{tournament.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default CurrentTournament;
